export const themes = {
  default: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16',
    thIcon: '',
  },
  column: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16',
    thIcon: '',
  },
  inline: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16',
    thIcon: '',
  },
};
